<template>
  <div id="cookie-consent" class="cookie-consent">
    <b-modal v-model="isActive" :can-cancel="false">
      <div class="cookie-infos has-background-grey-lighter">
        <strong class="title is-3">{{ $t("cookies.consent.headline") }}</strong>
        <p>{{ $t("cookies.consent.declaration") }}</p>
        <div class="cookie-consent__checkbox columns is-multiline">
          <label class="checkbox column is-half">
            <input
              type="checkbox"
              disabled
              checked
              v-model="cookies.essentialCookies"
            />
            {{ $t("cookies.consent.acceptEssential") }}
          </label>
          <label class="checkbox column is-half">
            <input type="checkbox" v-model="cookies.statisticCookies" />
            {{ $t("cookies.consent.acceptStatistics") }}
          </label>
          <label class="checkbox column is-half">
            <input type="checkbox" v-model="cookies.marketingCookies" />
            {{ $t("cookies.consent.acceptMarketing") }}
          </label>
        </div>
        <div class="buttons is-right">
          <!--button class="button is-rounded is-text" @click="revokeCookies()">{{ $t('cookies.consent.revoke') }}</button-->
          <button class="button is-rounded is-text" @click="saveCookies(false)">
            {{ $t("cookies.consent.save") }}
          </button>
          <button
            class="button is-rounded is-primary-dark"
            @click="saveCookies(true)"
          >
            {{ $t("cookies.consent.acceptAll") }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ModalView from "./ModalView";
import { eventBus } from "../../events/event-bus";

export default {
  name: "CookieConsent",
  components: {
    ModalView,
  },
  data() {
    return {
      cookies: {
        essentialCookies: true,
        statisticCookies: false,
        marketingCookies: false,
      },
      isActive: false,
    };
  },
  methods: {
    saveCookies(all) {
      if (all) {
        this.cookies.statisticCookies = true;
        this.cookies.marketingCookies = true;
        this.$gtm.enable(true);
      } else {
        this.$gtm.enable(false);
      }
      localStorage.setItem("cookies", JSON.stringify(this.cookies));

      if (this.checkIfBrowserIsIE()) {
        setTimeout(() => {
          eventBus.notification({
            duration: 20000,
            type: "warning",
            header: "Ihr Browser ist veraltet",
            body:
              "Sie verwenden einen Internet Explorer der Version 11 oder niedrieger. " +
              "Bitte verwenden Sie für eine bestmögliche Erfahrung einen Modernen Browser wie Microsoft Edge, Google Chrome oder Mozilla Firefox.",
          });
        }, 2000);
      }
      this.isActive = false;
      this.$router.push(this.$route.fullPath.replace(this.$route.hash, ""));
    },
    revokeCookies() {
      this.cookies.essentialCookies = false;
      this.cookies.statisticCookies = false;
      this.cookies.marketingCookies = false;
      this.$gtm.enable(false);
      localStorage.removeItem("cookies");
      window.location.reload();
    },
    checkIfBrowserIsIE() {
      let ua = window.navigator.userAgent;
      let msie = ua.indexOf("MSIE ");

      return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./); // If Internet Explorer, return version number
    },
  },
  watch: {
    $route(to, from) {
      console.log(to);
      if (to.hash === "#cookie-consent") {
        this.isActive = true;
      }
    },
  },
  mounted() {
    let localCookies = JSON.parse(localStorage.getItem("cookies"));
    if (!localCookies || this.$route.hash === "#cookie-consent") {
      this.isActive = true;
    } else {
      this.cookies = localCookies;
      if (
        localCookies["statisticCookies"] &&
        localCookies["marketingCookies"]
      ) {
        this.$gtm.enable(true);
      } else {
        this.$gtm.enable(false);
      }
    }
  },
};
</script>

<style scoped>
</style>